import {ActionTree, GetterTree, MutationTree} from "vuex";

interface CustomerState {
  fetchUser: () => void;
  notification: Notification;
}

interface Notification {
  isVisible: boolean;
  message: string;
}

const customerState: CustomerState = {
  fetchUser: () => {
    console.log('fetchUser function is not loaded yet')
  },
  notification: {
    isVisible: false,
    message: '',
  }
};

const customerGetters = {
  notification(state) {
    return state.notification;
  }
} as GetterTree<CustomerState, any>;

const customerMutations = {
  setFetchUser(state, fetchUser: () => void) {
    state.fetchUser = fetchUser
  },
  fetchUser(state) {
    state.fetchUser();
  },
  showNotification(state) {
    state.notification.isVisible = true;
  },
  hideNotification(state) {
    state.notification.isVisible = false;
  },
  setNotificationMessage(state, message) {
    state.notification.message = message;
  }
} as MutationTree<CustomerState>;

const customerActions = {
  updateFetchUserFunction({commit}, fetchUser: () => void) {
    commit('setFetchUser', fetchUser);
  },
  fetchUser({commit}) {
    commit('fetchUser');
  },
  showNotification({commit}, message) {
    commit('setNotificationMessage', message);
    commit('showNotification');
  },
  hideNotification({commit}) {
    commit('hideNotification');
  }
} as ActionTree<CustomerState, any>;

export const customerPageModule = {
  namespaced: true,
  state: customerState,
  getters: customerGetters,
  mutations: customerMutations,
  actions: customerActions,
};
